import { useAuth } from '@/hooks/useAuth';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { LogOut, LayoutDashboard } from 'lucide-react';

export const AdminPanel = () => {
  const { user, isAdmin, signOut } = useAuth();
  const navigate = useNavigate();

  if (!user) return null;

  const handleSignOut = async () => {
    await signOut();
    navigate('/');
  };

  return (
    <div className="fixed top-4 right-4 z-50 flex items-center gap-2 bg-background/80 backdrop-blur-sm border rounded-lg px-4 py-2 shadow-lg">
      <div className="text-sm">
        <p className="font-medium">{user.email}</p>
        {isAdmin && (
          <p className="text-xs text-primary">Admin</p>
        )}
      </div>
      {isAdmin && (
        <Button
          variant="ghost"
          size="icon"
          onClick={() => navigate('/admin')}
          aria-label="Admin Dashboard"
        >
          <LayoutDashboard className="h-4 w-4" />
        </Button>
      )}
      <Button
        variant="ghost"
        size="icon"
        onClick={handleSignOut}
        aria-label="Sign out"
      >
        <LogOut className="h-4 w-4" />
      </Button>
    </div>
  );
};
